import { useQuery } from "@tanstack/react-query";
import { fetchCatchments, fetchSchools } from "./service";
import type { Catchment, CatchmentSchool } from "./types";

export function useCatchments() {
  return useQuery<Catchment[]>({
    queryKey: ["catchments"],
    queryFn: fetchCatchments,
  });
}

export function useSchools() {
  return useQuery<CatchmentSchool[]>({
    queryKey: ["catchment-schools"],
    queryFn: fetchSchools,
  });
}
